export default "__VITE_ASSET__bdzI7Ufs__"